import React from "react";
import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  Text,
  typographyStyles,
} from "@fluentui/react-components";
import { isRemovalGroup, getRemovalChipLabel } from "src/features/selectors";
import { StyleChip } from "../style-chip";
import "./SelectedParagraphStyleTile.css";

import type { CharacterInfo, ParagraphInfo } from "src/types";

const useStyles = makeStyles({
  fullName: typographyStyles.subtitle2,
});

export interface SelectedParagraphStyleTileProps {
  isMultiSelect?: boolean;
  loading?: boolean;
  noSelectedCharacterStyle?: boolean;
  notInProfile?: boolean;
  selectedItem?: ParagraphInfo | CharacterInfo | null;
  selectedStyle?: string | null;
}

export function SelectedParagraphStyleTile({
  isMultiSelect,
  loading,
  noSelectedCharacterStyle,
  notInProfile,
  selectedItem,
  selectedStyle,
}: SelectedParagraphStyleTileProps) {
  const styles = useStyles();
  const isRemoval = !!selectedStyle && isRemovalGroup(selectedStyle);
  const chipLabel = isRemoval ? (getRemovalChipLabel(selectedStyle!) ?? selectedStyle) : selectedStyle;

  return loading ? (
    <div className="selected-paragraph-style-tile-loading">
      <Skeleton>
        <SkeletonItem style={{ height: "22px" }} />
      </Skeleton>
      <Skeleton>
        <SkeletonItem style={{ height: "28px" }} />
      </Skeleton>
    </div>
  ) : (
    <div className="selected-paragraph-style-tile">
      <StyleChip
        className="selected-paragraph-style-tile-style-chip"
        noSelectedCharacterStyle={noSelectedCharacterStyle}
        notInProfile={notInProfile}
        removal={isRemoval}
      >
        {isMultiSelect ? "\u2013" : chipLabel}
      </StyleChip>
      <Text className={styles.fullName}>
        {noSelectedCharacterStyle
          ? "No character style"
          : isMultiSelect
            ? "Mixed Paragraph Styles"
            : selectedItem?.fullStyleName}
      </Text>
    </div>
  );
}
